import { useRef, useState, useEffect, React } from "react";
import { useBlogContext } from "../../fetchdata/BlogContext";
import Header from "../components/Header"; // Replace this with your Header component
import Footer from "../components/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import axiosInstance from '../../axiosInstance';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { Helmet } from "react-helmet";
import HeaderPage from "../components/HeaderPage";
import NavBar from "../components/NavBar";

const Category = () => {

  const swiperRefLocal = useRef();

  const handleMouseEnter = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.stop();
  };

  const handleMouseLeave = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.start();
  };


  const [layout, setLayout] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [isProducts, setIsProducts] = useState(true);

  const [RProducts, setRProducts] = useState([]);


  const getProducts = async () => {
    try {
      const { data } = await axiosInstance.get("/all-home-products");
      setRProducts(data.products);
      setIsProducts(false); // Set loading state to false in case of an error
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false); // Set loading state to false in case of an error
    }
  };

  const getData = async () => {
    try {
      const { data } = await axiosInstance.get(`/home-layout-data`);
      setLayout(data.homeLayout);
      setIsLoading(false); // Set loading state to false in case of an error
    }
    catch (error) {
      console.log(error);
      toast.error("Error fetching Home layout!");
      setIsLoading(false); // Set loading state to false in case of an error
    }
  };

  useEffect(() => {
    getData();
    getProducts();
  }, []);





  const startMin = 0;
  const startMax = 100;
  const min = 0;
  const max = 200;
  const step = 1;

  const [selectedRanges, setSelectedRanges] = useState([]);

  const [selectedFilters, setSelectedFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [Cat, setCat] = useState([]);
  const [CatT, setTCat] = useState("");
  const [CatImage, setTCatImage] = useState("");

  const [CatM, setMCat] = useState([]);

  const [Pro, setPro] = useState([]);
  const [Attr, setAttr] = useState([]);
  const [fillter, setfillter] = useState('');

  const [Viewfillter, setViewfillter] = useState([]);


  const [isCat, setIsCat] = useState(true);
  const [count, setcount] = useState('100');
  const [Sidebar, setIsSidebar] = useState(false);



  const handlecountChange = (event) => {
    setcount(event.target.value);
  };

  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [ratings, setRatings] = useState([]);


  const getRating = async () => {
    try {
      const { data } = await axiosInstance.get(`/all-rating`);
      setRatings(data.ratings);
      // console.log('getRating', data)

    } catch (error) {
      console.error("Error fetching rating:", error);
    }
  };

  const getCategory = async (fillter, page, price) => {
    setIsSidebar(false)
    try {
      window.scrollTo(0, 0);
      setIsCat(true);
      const encodedFilter = encodeURIComponent(fillter); // Encode the filter string

      const { data } = await axiosInstance.get(`/all/category-slug/${id}?filter=${encodedFilter}&price=${price}&page=${page}&perPage=${count}`);
      setCat([]);
      setTCat("");
      setMCat([])
      if (data?.success) {
        setCat(data?.categories);
        setTCat(data.MainCat.title);
        setTCatImage(data.MainCat.image)
        setTotalPages(data?.proLength);
        setfillter(fillter);

        setProducts(data?.productsFilter);

        setPro(data?.products);
        setMCat(data?.MainCat)
      }

      // console.log('datadatadata', data)
    } catch (error) {
      console.log(error);
      toast.error("Error fetching Category!");
    } finally {
      setIsCat(false);
    }
  };

  const Opensidebar = async () => {
    setIsSidebar(true)
  }
  const Closesidebar = async () => {
    setIsSidebar(false)
  }

  const getAttribute = async () => {
    try {
      const { data } = await axiosInstance.get("/all-attribute");
      // console.log("attr", data);
      setAttr(data.Attribute);
    } catch (error) {
      console.error("Error fetching attributes:", error);
    }
  };

  // Function to handle checkbox selection
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    // console.log('valuevaluevalue', value)
    setSelectedFilters((prevState) => {
      // If checked, add the value to selectedFilters, otherwise remove it
      if (checked) {
        return { ...prevState, [value]: checked };
      } else {
        const { [value]: removedValue, ...rest } = prevState;
        return rest;
      }
    });

    // console.log('selectedFilters', selectedFilters)
    setCurrentPage(1);
  };

  const removeFilter = ({ key, val }) => {
    const value = `${key},${val}`;
    setSelectedFilters((prevState) => {
      const { [value]: removedValue, ...rest } = prevState;
      return rest;
    });

    setCurrentPage(1); // Set current page to 1
  };




  const generateQueryString = () => {
    const filterObj = {};

    // Construct filter object from selected filters
    Object.entries(selectedFilters).forEach(([key, value]) => {
      const [attrKey, attrValue] = key.split(",");

      // Check if attribute key already exists in filter object
      if (filterObj[attrKey]) {
        // Append to existing attribute value if key exists
        filterObj[attrKey] += `,${attrValue}`;
      } else {
        // Create new attribute if key doesn't exist
        filterObj[attrKey] = attrValue;
      }
    });

    // Convert filter object to JSON string
    const filterString = JSON.stringify(filterObj);

    // console.log(filterString); // Output the generated filter string
    setViewfillter(filterString)
    setTimeout(function () { getCategory(filterString, currentPage, selectedRanges); }, 100);
  };

  // const handleCategoryLinkClick = (categoryId) => {
  //   getCategory(fillter, currentPage, selectedRanges);
  // };

  useEffect(() => {
    generateQueryString(); // Call generateQueryString when selectedFilters change
    getRating();
    setIsCat(true); // Set loading state to true
    getAttribute();
    // getCategory(fillter,currentPage,selectedRanges);
  }, [id, currentPage, selectedFilters, selectedRanges, count]); // Empty dependency array ensures that the effect runs once after the initial render

  useEffect(() => {
    setSelectedRanges([]);
  }, [id]); // Empty dependency array ensures that the effect runs once after the initial render

  // useEffect(() => {
  //   generateQueryString(); // Call generateQueryString when selectedFilters change
  // }, [selectedFilters,selectedRanges]); // Add selectedFilters as a dependency

  // Function to filter products based on selected attributes

  const [priceRange, setPriceRange] = useState({ min: 0, max: 100 });

  function handleChange(e) {
    setPriceRange({
      priceRange,
      [e.target.name]: parseInt(e.target.value),
    });
  }


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };



  // Calculate the maximum sale price to determine the range
  const maxSalePrice = Math.max(...products.map(product => product.salePrice));

  // Determine the number of ranges based on the maximum sale price
  const numRanges = Math.ceil(maxSalePrice / 10000);

  // Generate price ranges dynamically
  const priceRanges = Array.from({ length: numRanges }, (_, index) => ({
    min: index * 10000,
    max: (index + 1) * 10000,
  }));

  // Filter out the price ranges that match the actual sale prices of your products
  const filteredPriceRanges = priceRanges.filter(range =>
    products.some(product =>
      product.salePrice >= range.min && product.salePrice < range.max
    )
  );

  const handleCheckpriceboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedRanges([...selectedRanges, value]);
    } else {
      setSelectedRanges(selectedRanges.filter(range => range !== value));
    }
    setCurrentPage(1);
    // console.log(selectedRanges)
  };



  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const isVideo = (url) => /\.(mp4|webm|ogg)$/i.test(url);



  return (
    <>




      <HeaderPage title={!isCat ? CatM?.metaTitle || 'Not Found' : ''} />

      <main className="page-content  mypadding overflow-auto pb-4 px-0" >



        <div className=" px-3 py-2">

          <section className="mt-2">
            {CatImage !== undefined && CatImage !== '' ? (<>
              <img src={CatImage} width={'100%'} className="rounded" style={{ aspectRatio: "5/1", objectFit: "cover" }} />
            </>) : (
              <div className=" skeleton w-100" style={{ height: 100 }} />
            )}

          </section>

          <div className=" p-0 position-relative mt-3  " onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave} style={{ zIndex: 2 }} >
            <Swiper
              slidesPerView={1}
              spaceBetween={12}
              pagination={false}
              navigation={false}
              breakpoints={{
                300: {
                  slidesPerView: 2.8,
                },
                640: {
                  slidesPerView: 2.8,
                },
                768: {
                  slidesPerView: 2.8,
                },
                1024: {
                  slidesPerView: 3.2,
                },
              }}
              ref={swiperRefLocal}
              autoplay={{
                delay: 1000,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              modules={[Pagination, Navigation, Autoplay]} className="book-now pb-0 ">

              {isCat
                ? Array.from({ length: 4 }).map((_, index) => (
                  <SwiperSlide
                    className="skeleton"
                    style={{
                      width: "100%",
                      aspectRatio: "179/222",
                    }}
                  ></SwiperSlide>
                ))
                : (
                  <>


                    {Cat.map((category, index) => (


                      <SwiperSlide key={index} >
                        <Link to={`/${category?.slug}`} className="border rounded text-center d-block pb-3 pt-2"  >
                          <img
                            src={category?.image}
                            className="img-fluid d-block p-4 w-100"
                            alt="img"
                            style={{ aspectRatio: '1/1' }}
                          />
                          <p className="m-0"> {category?.title} </p>
                        </Link>
                      </SwiperSlide>

                    ))}


                  </>
                )}


            </Swiper>
          </div>


          {CatImage !== undefined && CatImage !== '' ? (<>
            <section className="d-flex px-2 py-1 rounded mt-3 border g-4 align-items-center me-3 ">
              <div className="col">
                <div className="row g-2">
                  <label
                    htmlFor="sorting"
                    className="col-auto col-form-label "
                  >
                    No of products
                  </label>
                  <div className="col-auto">
                    <select className="form-select" id="sorting" value={count} onChange={handlecountChange} >
                      <option value="50">50</option>
                      <option value="100">100</option>

                      <option value="200">200</option>

                      <option value="500">500</option>

                    </select>
                  </div>
                </div>
              </div>
            </section>
          </>) : (
            <div className=" skeleton w-100 mt-3" style={{ height: 40 }} />
          )}


          <div className="row pt-2 mx-n2 mb-4 mb-sm-8">
            {isCat
              ? Array.from({ length: 6 }).map((_, index) => (
                <div
                  key={index}
                  className="col-6 mt-4"
                >
                  <div
                    className="card-1 skeleton"
                    style={{ height: 300, borderRadius: 5 }}
                  ></div>

                </div>
              ))
              : Pro.map((Pro) => {
                // Calculate average rating for the current product
                const productRatings = ratings.filter(rating => rating.productId === Pro._id);
                const totalRatings = productRatings.length;
                const totalRatingValue = productRatings.reduce((acc, curr) => acc + curr.rating, 0);
                const averageRating = totalRatings > 0 ? totalRatingValue / totalRatings : 0;

                return (
                  <>

                    {/* Product Card */}
                    <div className="col-6 mb-4">


                      <div className="dz-card h-100">
                        <div className="dz-media">

                          {/* Product Image / Video */}
                          <Link to={`/product/${Pro.slug}`}>
                            {isVideo(Pro.pImage) ? (
                              <video
                                src={Pro.pImage}
                                autoPlay
                                muted
                                loop
                                playsInline
                                className="img-fluid"
                                style={{ aspectRatio: "1/1", objectFit: "cover" }}
                              />
                            ) : (
                              <img
                                src={Pro.pImage || "/assets/img/square-placeholder.jpg"}
                                alt={Pro.title}
                                style={{ aspectRatio: "1/1", objectFit: "cover" }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = "/assets/img/square-placeholder.jpg";
                                }}
                              />
                            )}
                          </Link>

                          {/* Wishlist Button */}
                          <button
                            type="button"
                            className="item-bookmark"
                          >
                            <i className="feather icon-heart"></i>
                          </button>
                        </div>

                        <div className="dz-content">

                          {/* Product Title */}
                          <h5 className="title truncate-two-lines">
                            <Link to={`/product/${Pro.slug}`}>
                              {Pro.title}
                            </Link>
                          </h5>

                          {/* Price */}
                          <div className="dz-price">
                            ₹{Pro.salePrice}
                            {Pro.regularPrice > Pro.salePrice && (
                              <del>₹{Pro.regularPrice}</del>
                            )}
                          </div>

                          {/* Discount Badge */}
                          {Pro.regularPrice > Pro.salePrice && (
                            <div className="dz-off">
                              {Math.round(
                                ((Pro.regularPrice - Pro.salePrice) /
                                  Pro.regularPrice) *
                                100
                              )}
                              % Off
                            </div>
                          )}

                          {/* Add To Cart Button */}
                          {/* <button
                            type="button"
                            className="cart-btn"
                          >
                            <i className="ri-shopping-cart-line"></i>
                          </button> */}

                        </div>
                      </div>


                    </div>


                  </>
                );
              })}

            {Pro.length === 0 && !isCat && (
              <div
                className="container mx-auto my-2 mt-5 py-2 text-center"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",

                }}
              >
                <div>

                  <img src="/assets/img/product-not-found.png" alt="no product" className="d-block mx-auto mb-3" style={{ maxWidth: 200 }} />
                  <p>No products found for this category.</p>
                </div>
              </div>

            )}

            <hr className="d-none d-sm-block" />

            <div className="d-flex justify-content-between mt-6">
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" type="button" onClick={() => handlePageChange(currentPage - 1)}><i className="ri-arrow-left-s-line me-1"></i>Prev</button>
                </li>
              </ul>

              <ul className="pagination">
                <li className={`page-item ${totalPages === 0 ? 'disabled' : ''}`}>
                  <button className="page-link" type="button" onClick={() => handlePageChange(currentPage + 1)} aria-label="Next">Next<i className="ms-1 ri-arrow-right-s-line"></i></button>
                </li>
              </ul>
            </div>


            {/* Pagination */}
          </div>


        </div>

        <NavBar />

      </main>


    </>
  );
};

export default Category;
